import React, { useEffect, useRef, createContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout, loadCredentials } from 'src/redux/slices/auth';
import { setSocketAuth, resetSocketState } from 'src/redux/slices/socketStates';
import { useOverlay } from './OverlayContext';
import { Typography, Button } from '@material-ui/core';

const shouldShowOverlay = (target, currentUser) => {
  if (target === 'all') return true;
  if (target === 'ru') return currentUser.ru === 1;
  if (target === 'users') return currentUser.ru !== 1;
  if (target === 'none') return false;
  return false; // safety fallback
};

const BroadCastContext = createContext(null);

const BroadCastProvider = ({ children }) => {
  const channelRef = useRef(new BroadcastChannel('general'));
  const tabId = useRef(`${Date.now()}-${Math.random()}`);
  const { setOverlay } = useOverlay();
  const dispatch = useDispatch();
  const current_user = useSelector(state => state.auth.current_user);
  const currentUserRef = useRef(current_user);

  useEffect(() => {
    currentUserRef.current = current_user;
  }, [current_user]);

  //functions for listeners
  const LISTENERS = {
    login: data => {
      dispatch(setSocketAuth(data));
      dispatch(loadCredentials(data));
    },
    logout: data => {
      dispatch(resetSocketState());
      dispatch(logout());
    },
    selectBiz: data => {
      const target = data?.target ?? 'none'; // default to all
      if (shouldShowOverlay(target, currentUserRef.current)) {
        setOverlay({
          open: true,
          component: (
            <React.Fragment>
              <Typography variant="h2" style={{ whiteSpace: 'pre-wrap' }}>
                {data?.text ?? 'Active Biz has been switched\nPlease reload.'}
              </Typography>
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                style={{ marginTop: 16 }}
                onClick={() => window.location.reload()}
              >
                Reload
              </Button>
            </React.Fragment>
          ),
          style: {
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }
        });
      }
    }
  };

  useEffect(() => {
    const channel = channelRef.current;

    channel.onmessage = event => {
      const { type, source, ...data } = event.data;
      if (source === tabId.current) return;
      const handler = LISTENERS[type];

      if (handler) {
        handler(data);
      }
    };

    return () => {
      channel.close();
    };
  }, [dispatch]);

  return (
    <BroadCastContext.Provider
      value={{
        channel: channelRef.current,
        tabId: tabId.current
      }}
    >
      {children}
    </BroadCastContext.Provider>
  );
};

export default BroadCastContext;
export { BroadCastProvider };
